// layouts
import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout
import Dashboard from "@/views/admin/Dashboard.vue";
import Perfil from "@/views/admin/Perfil.vue";

// CRUDs
import CargoList from "@/views/admin/CargoList.vue";
import CargoShow from "@/views/admin/CargoShow.vue";
import ContactoList from "@/views/admin/ContactoList.vue";
import ContactoShow from "@/views/admin/ContactoShow.vue";
import CuentaList from "@/views/admin/CuentaList.vue";
import CuentaShow from "@/views/admin/CuentaShow.vue";
import Directo_horaShow from "@/views/admin/Directo_horaShow.vue";
import EmpresaList from "@/views/admin/EmpresaList.vue";
import EmpresaShow from "@/views/admin/EmpresaShow.vue";
import HoraList from "@/views/admin/HoraList.vue";
import HoraShow from "@/views/admin/HoraShow.vue";
import LicenciaList from "@/views/admin/LicenciaList.vue";
import LicenciaShow from "@/views/admin/LicenciaShow.vue";
import MonedaList from "@/views/admin/MonedaList.vue";
import MonedaShow from "@/views/admin/MonedaShow.vue";
import ObraList from "@/views/admin/ObraList.vue";
import ObraShow from "@/views/admin/ObraShow.vue";
import Pago_categoriaList from "@/views/admin/Pago_categoriaList.vue";
import Pago_categoriaShow from "@/views/admin/Pago_categoriaShow.vue";
import Pago_subcategoriaShow from "@/views/admin/Pago_subcategoriaShow.vue";
import OficinaList from "@/views/admin/OficinaList.vue";
import OficinaShow from "@/views/admin/OficinaShow.vue";
import FeriadoList from "@/views/admin/FeriadoList.vue";
import FeriadoShow from "@/views/admin/FeriadoShow.vue";
import PersonalList from "@/views/admin/PersonalList.vue";
import PersonalShow from "@/views/admin/PersonalShow.vue";
import PresupuestoList from "@/views/admin/PresupuestoList.vue";
import PresupuestoShow from "@/views/admin/PresupuestoShow.vue";
import ProyectosPorPersonal from "@/views/admin/ProyectosPorPersonal.vue";
import RolList from "@/views/admin/RolList.vue";
import RolShow from "@/views/admin/RolShow.vue";
import TareaList from "@/views/admin/TareaList.vue";
import TareaShow from "@/views/admin/TareaShow.vue";
import TransaccionList from "@/views/admin/TransaccionList.vue";
import TransaccionShow from "@/views/admin/TransaccionShow.vue";
import UsuarioList from "@/views/admin/UsuarioList.vue";
import UsuarioShow from "@/views/admin/UsuarioShow.vue";

// Delete following examples components
import Tables from "@/views/admin/Tables.vue";

// views for Auth layout
import Login from "@/views/auth/Login.vue";

// routes
export const routes = [
  {
    path: "/",
    component: Admin,
    children: [
      {
        path: "/",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          label: "Inicio",
          icon: "home",
        },
      },
      {
        path: "/mis-horas",
        component: HoraList,
        meta: {
          requiresAuth: true,
          label: "Mis horas",
          icon: "clock",
          roles: ["personal", "coordinador", "supervisor de empresa"],
        },
      },
      {
        path: "/mis-horas/:id",
        component: HoraShow,
        meta: {
          requiresAuth: true,
          roles: ["personal", "coordinador", "supervisor de empresa"],
          hideOnMenu: true,
        },
      },
      {
        path: "/mis-proyectos",
        component: ProyectosPorPersonal,
        meta: {
          requiresAuth: true,
          label: "Mis Proyectos",
          icon: "boxes",
          roles: ["personal", "coordinador", "supervisor de empresa"],
        },
      },
      {
        path: "/perfil",
        component: Perfil,
        meta: {
          requiresAuth: true,
          hideOnMenu: true,
        },
      },
      // Operativo
      {
        path: "/proyectos",
        component: PresupuestoList,
        meta: {
          requiresAuth: true,
          label: "Presupuestos",
          icon: "boxes",
          roles: ["admin", "coordinador", "supervisor de empresa"],
          group: ["Operativo"],
        },
      },
      {
        path: "/proyectos/:id",
        component: PresupuestoShow,
        meta: {
          requiresAuth: true,
          roles: ["admin", "coordinador", "supervisor de empresa"],
          hideOnMenu: true,
        },
      },
      {
        path: "/empresas",
        component: EmpresaList,
        meta: {
          requiresAuth: true,
          label: "Empresas",
          icon: "building",
          roles: ["admin"],
          group: ["Operativo"],
        },
      },
      {
        path: "/empresas/:id",
        component: EmpresaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/obras",
        component: ObraList,
        meta: {
          requiresAuth: true,
          label: "Obras",
          icon: "box",
          roles: ["admin"],
          group: ["Operativo"],
        },
      },
      {
        path: "/obras/:id",
        component: ObraShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/contactos",
        component: ContactoList,
        meta: {
          requiresAuth: true,
          label: "Contactos",
          icon: "address-book",
          roles: ["admin"],
          group: ["Operativo"],
        },
      },
      {
        path: "/contactos/:id",
        component: ContactoShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      // Finanzas
      {
        path: "/transacciones",
        component: TransaccionList,
        meta: {
          requiresAuth: true,
          label: "Transacciones",
          icon: "exchange",
          roles: ["admin"],
          group: ["Finanzas"],
        },
      },
      {
        path: "/transacciones/:id",
        component: TransaccionShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      // Personal
      {
        path: "/personal",
        component: PersonalList,
        meta: {
          requiresAuth: true,
          label: "Personal",
          icon: "users",
          roles: ["admin", "coordinador", "supervisor de empresa"],
          group: ["Personal"],
        },
      },
      {
        path: "/personal/:id",
        component: PersonalShow,
        meta: {
          requiresAuth: true,
          roles: ["admin", "coordinador", "supervisor de empresa"],
          hideOnMenu: true,
        },
      },
      {
        path: "/directo_horas/:id",
        component: Directo_horaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/horas",
        component: HoraList,
        meta: {
          requiresAuth: true,
          label: "Horas",
          icon: "clock",
          roles: ["admin", "coordinador", "supervisor de empresa"],
          group: ["Personal"],
        },
      },
      {
        path: "/horas/:id",
        component: HoraShow,
        meta: {
          requiresAuth: true,
          roles: ["admin", "personal", "coordinador", "supervisor de empresa"],
          hideOnMenu: true,
        },
      },
      {
        path: "/feriados",
        component: FeriadoList,
        meta: {
          requiresAuth: true,
          label: "Feriados",
          icon: "calendar",
          roles: ["admin"],
          group: ["Personal"],
        },
      },
      {
        path: "/feriados/:id",
        component: FeriadoShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/licencias",
        component: LicenciaList,
        meta: {
          requiresAuth: true,
          label: "Licencias",
          icon: "calendar-xmark",
          roles: ["admin"],
          group: ["Personal"],
        },
      },
      {
        path: "/licencias/:id",
        component: LicenciaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin", "personal", "coordinador", "supervisor de empresa"],
          hideOnMenu: true,
        },
      },
      // Configuraciones
      // RRHH
      {
        path: "/cargos",
        component: CargoList,
        meta: {
          requiresAuth: true,
          label: "Cargos",
          icon: "shield-halved",
          roles: ["admin"],
          group: ["Configuración", "Recursos Humanos"],
        },
      },
      {
        path: "/cargos/:id",
        component: CargoShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/oficinas",
        component: OficinaList,
        meta: {
          requiresAuth: true,
          label: "Oficina",
          icon: "building",
          roles: ["admin"],
          group: ["Configuración", "Recursos Humanos"],
        },
      },
      {
        path: "/oficinas/:id",
        component: OficinaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/tareas",
        component: TareaList,
        meta: {
          requiresAuth: true,
          label: "Tareas",
          icon: "list-check",
          roles: ["admin"],
          group: ["Configuración", "Recursos Humanos"],
        },
      },
      {
        path: "/tareas/:id",
        component: TareaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/roles",
        component: RolList,
        meta: {
          requiresAuth: true,
          label: "Roles",
          icon: "lock-open",
          roles: ["admin"],
          group: ["Configuración", "Recursos Humanos"],
        },
      },
      {
        path: "/roles/:id",
        component: RolShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/usuarios",
        component: UsuarioList,
        meta: {
          requiresAuth: true,
          label: "Usuarios",
          icon: "user-shield",
          roles: ["admin"],
          group: ["Configuración", "Recursos Humanos"],
        },
      },
      {
        path: "/usuarios/:id",
        component: UsuarioShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      // Finanzas
      {
        path: "/cuentas",
        component: CuentaList,
        meta: {
          requiresAuth: true,
          label: "Cuentas",
          icon: "wallet",
          roles: ["admin"],
          group: ["Configuración", "Finanzas"],
        },
      },
      {
        path: "/cuentas/:id",
        component: CuentaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/monedas",
        component: MonedaList,
        meta: {
          requiresAuth: true,
          label: "Monedas",
          icon: "money-bill",
          roles: ["admin"],
          group: ["Configuración", "Finanzas"],
        },
      },
      {
        path: "/monedas/:id",
        component: MonedaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/pago_categorias",
        component: Pago_categoriaList,
        meta: {
          requiresAuth: true,
          label: "Categorías de pago",
          icon: "cash-register",
          roles: ["admin"],
          group: ["Configuración", "Finanzas"],
        },
      },
      {
        path: "/pago_categorias/:id",
        component: Pago_categoriaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      {
        path: "/pago_subcategorias/:id",
        component: Pago_subcategoriaShow,
        meta: {
          requiresAuth: true,
          roles: ["admin"],
          hideOnMenu: true,
        },
      },
      // TODO Delete following example pages
      {
        path: "/tables",
        component: Tables,
        meta: {
          requiresAuth: true,
          hideOnMenu: true,
        },
      },
    ],
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        component: Login,
        meta: { guestOnly: true },
      },
    ],
  },
  // { path: "/:pathMatch(.*)*", redirect: "/" },
];
